
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { getErrorMessage } from '@/util/errorMessageHelper';
import restService from '@/services/restService';
import RideitPassengerToken from '@/models/Rideit/RideitPassengerToken';
import RideitPassengerTokenCard from '@/components/Organization/Rideit/RideitPassengerTokenCard.vue';

type PanelState = null | 0;
const PanelStates = {
  Closed: null,
  Open: 0,
} as const;

@Component({
  components: {
    RideitPassengerTokenCard,
  },
})
export default class RideitPassengerTokenList extends Vue {
  @Prop({ required: true }) private passengerId: number;
  @Prop({ required: true }) private organizationId: string;

  tokens: RideitPassengerToken[] = [];
  errorMessage: string | null = null;
  loading = false;
  cancelling = false;
  panel: PanelState = PanelStates.Closed;

  get tokensAmount() {
    return this.tokens?.length ?? 0;
  }

  get headerText() {
    if (this.errorMessage) {
      return this.$t('rideIt.tokens.passengerTokensAmount', { amount: this.$t('generic.error.singular') });
    }
    return this.$t('rideIt.tokens.passengerTokensAmount', { amount: this.tokensAmount });
  }

  get disabled() {
    const claims = [
      this.tokensAmount === 0 && !Boolean(this.errorMessage),
      this.loading,
      this.cancelling,
    ];

    return claims.some(Boolean);
  }

  handleError(error: unknown) {
    // Get the error message
    this.errorMessage = getErrorMessage(error);
    // Force the panel open to show the error
    this.panel = PanelStates.Open;
    // Log the full error
    console.error(error);
  }

  async cancelToken(token: RideitPassengerToken) {
    if (!confirm(this.$t('rideIt.tokens.cancelConfirmation'))) {
      return;
    }

    this.cancelling = true;
    try {
      const cancelledToken = await restService.rideit.cancelToken(token.id, this.organizationId);
      this.tokens = this.tokens.filter(t => t.id !== cancelledToken.id);
    } catch (error: unknown) {
      this.handleError(error);
    } finally {
      this.cancelling = false;
    }
  }

  async getPassengerTokens() {
    this.loading = true;

    try {
      const rideitTokens = await restService.rideit.getTokensForPassenger(this.passengerId);
      return rideitTokens
        // .filter(t => !Boolean(t.revokedBy)) 
        .map(t => new RideitPassengerToken(t));

    } catch (error: unknown) {
      this.handleError(error);
    } finally {
      this.loading = false;
    }
  }

  async mounted() {
    this.tokens = await this.getPassengerTokens();
  }


}
